export const LOGO_PLACEMENT = {
    TOP: 'TOP',
    BOTTOM_LEFT: 'BOTTOM_LEFT',
    TOP_LEFT: 'TOP_LEFT',
};
